import { openPaperform } from './openPaperform';

export interface IdlePopupOptions {
  enabled: boolean;
  interval: number;
  formId: string;
}

/*
 * idlePopup
 *
 * Show the user a popup form after N seconds of inactivity.
 *
 * "Inactivity" means no scroll, touch, click, or keydown events.
 *
 * The popup will not be displayed if any of these is true:
 * - The popup is disabled on the server (e.g. if user is logged in).
 * - The popup has already been shown on this page.
 * - The popup has already been shown in this session
 *   (as determined by the idlePopupShown session cookie).
 */

const popupOptions: IdlePopupOptions = {
  enabled: false,
  formId: '',
  interval: 0,
};
let popupTimer: number | undefined;
let hasShownPopup: boolean = false;

export function initIdlePopup(options: IdlePopupOptions) {
  Object.assign(popupOptions, options);
  if (popupOptions.enabled && idlePopupEnabled()) {
    startPopupTimer();
    watchEvents();
  }
}

function watchEvents() {
  window.addEventListener('scroll', startPopupTimer, { passive: true });
  window.addEventListener('click', startPopupTimer);
  window.addEventListener('touchstart', startPopupTimer);
  window.addEventListener('keydown', startPopupTimer);
}

function startPopupTimer() {
  window.clearTimeout(popupTimer);
  popupTimer = window.setTimeout(showIdlePopup, popupOptions.interval * 1000);
}

function showIdlePopup() {
  if (idlePopupEnabled()) {
    hasShownPopup = true;
    document.cookie = 'idlePopupShown=true; path=/';
    openPaperform(popupOptions.formId);
  }
}

function idlePopupEnabled(): boolean {
  return popupOptions.enabled && !hasShownPopup && !window.getCookie('idlePopupShown');
}
